import { Link } from 'react-router-dom';
import cn from 'classnames';
import { ReactNode, useMemo, forwardRef } from 'react';

import checkIsNewSubgroup from 'common/components/Sidebar/utils/checkIsNewSubgroup';
import { Category, Section } from 'common/selectors/sidebar/utils';

import s from '../../styles.module.css';
import { SidebarViewProps } from '../..';
import LabelNew from '../LabelNew';

type SubgroupTabProps = {
  path: string;
  href: string;
  isSubgroupActive: boolean;
  collapsed: boolean;
  newLabelText: ReactNode;
} & Pick<SidebarViewProps, 'dangers' | 'collapsed'> &
  Pick<Category, 'path'> &
  Pick<Section, 'title'>;

const SubgroupTab = forwardRef<HTMLAnchorElement, SubgroupTabProps>(
  (
    { title, path, href, isSubgroupActive, collapsed, dangers, newLabelText },
    ref,
  ) => {
    const isShowNewLabel = useMemo(() => checkIsNewSubgroup(path), [path]);

    return (
      <Link
        ref={ref as never}
        key={path}
        to={href}
        className={cn(s.sidebarItem, s.subGroupItem, {
          [s.subGroupItemCollapsed]: collapsed,
          [s.subGroupItemActive]: isSubgroupActive,
        })}
      >
        {collapsed ? title : <span className={s.itemTitle}>{title}</span>}
        {isShowNewLabel && <LabelNew text={newLabelText} />}
        {dangers[path] && !collapsed && (
          <span qa-element="dangers-sidebar" className={s.unreadNews}>
            {Number.isInteger(dangers[path]) ? dangers[path] : '!'}
          </span>
        )}
      </Link>
    );
  },
);

export default SubgroupTab;
